import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

const VipCardContainer = styled.div`
  border-radius: ${pxToRem('5px')};
  background-color: ${props => props.theme.colors.fucsia};
  width: ${pxToRem('25px')};
  height: ${pxToRem('16px')};
  text-align: center;
  padding-top: ${pxToRem('3px')};
  margin: ${props => props.margin};
`;

export { VipCardContainer };
